import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TravelArticle } from '../models/travel-article.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TravelArticlesService = /** @class */ (function () {
    function TravelArticlesService(_http, _errorHandler) {
        this._http = _http;
        this._errorHandler = _errorHandler;
    }
    /**
     * returns Array of Travel Articles for an airport
     */
    TravelArticlesService.prototype.getArticles = function (ident) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var URL, RESPONSE, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        URL = environment.travelArticleApiUrl + "&airportident=" + ident;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._http.get(URL).toPromise()];
                    case 2:
                        RESPONSE = _a.sent();
                        // let RESPONSE = await this._http.get<any>(`assets/sample/travel/${ident}.json`).toPromise();
                        if (!RESPONSE) {
                            return [2 /*return*/, ([]).map(function (d) { return TravelArticle.parse(d); })];
                            // this._errorHandler.handleError(new Error('API did not return valid countries Obj'));
                        }
                        else {
                            // return (RESPONSE || []).map(d => TravelArticle.parse(d));
                            RESPONSE = RESPONSE.DestinationsArticles.Articles;
                            return [2 /*return*/, (RESPONSE || []).map(function (d) { return TravelArticle.parse(d); }).filter(function (f) { return f.Topics.includes('destinations'); })];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // this._errorHandler.handleError(e);
                        // throw e;
                        return [2 /*return*/, ([]).map(function (d) { return TravelArticle.parse(d); })];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TravelArticlesService.ngInjectableDef = i0.defineInjectable({ factory: function TravelArticlesService_Factory() { return new TravelArticlesService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: TravelArticlesService, providedIn: "root" });
    return TravelArticlesService;
}());
export { TravelArticlesService };
